module.exports = __webpack_public_path__ + "static/media/16UNODC23.c4d1c489.jpg";